export const LargeTitle = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={`font-semibold text-2xl text-center lg:text-4xl lg:text-left lg:mt-8 mb-4 ${className} `}
    >
      {children}
    </div>
  );
};
